export default __webpack_public_path__ + "static/media/012.784f9c49.webp";